import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { IDetailedReportSearch } from '../models/detailed-report-search.model';
import { IDetailedReportGrid } from '../models/detailed-report-grid.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonModule, DatePipe } from '@angular/common';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { ReportService } from '../../services/report/report.service';
import { RequestDetailsViewComponent } from '../../manage-request/request-details-view/request-details-view.component';
import * as XLSX from 'xlsx';

export type DetailedReportControls = {
  [K in keyof IDetailedReportSearch]: FormControl<string>;
};

@Component({
  selector: 'app-detailed-report-grid',
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule, MatTableModule, CommonModule, MatPaginatorModule, MatProgressSpinnerModule],
  templateUrl: './detailed-report-grid.component.html',
  styleUrl: './detailed-report-grid.component.scss',
  providers: [DatePipe]
})
export class DetailedReportGridComponent implements OnInit {
  isLoading: boolean = false;
  pagedData : PagedResult<IDetailedReportGrid[]>;
  dataSource: MatTableDataSource<IDetailedReportGrid>;
  searchParams: SearchParameters<IDetailedReportSearch>
  displayedColumns: string[] = ['request', 'requestType', 'division', 'employee', 'status', 'amount', 'currency', 'approvedBy', 'enteredDate', 'approvedDate', 'approvingDays', 'sentToJdeDate', 'daysInFinance'];
  pageSize: number = 10;
  totalCount: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SearchParameters<IDetailedReportSearch>,
    public dialogRef: MatDialogRef<DetailedReportGridComponent>,
    private reportService: ReportService,
    private modal: MatDialog
    ) {
  }

  ngOnInit(): void {
    this.searchParams = this.data;
    this.search(this.searchParams);
  }

  search(searchParams: SearchParameters<IDetailedReportSearch>) {
    this.isLoading = true;
    this.reportService.search(searchParams)
      .subscribe(data => {        
        this.pagedData = data;       
        this.pageSize = this.data.pageSize;
        this.totalCount = this.pagedData.totalCount;      
        this.dataSource = new MatTableDataSource<IDetailedReportGrid>(this.pagedData.items);
        this.isLoading = false;
      });
  }

  public pageChangeEvent(event?:PageEvent){
    this.searchParams.pageIndex = event.pageIndex;
    this.searchParams.pageSize = event.pageSize;
    this.search(this.searchParams);
  }

  exportAllToExcel(){
    var searchParams = this.searchParams;
    searchParams.pageSize = this.totalCount;

    this.reportService.search(searchParams).subscribe(data => {
      this.exportToExcel(data.items);
    });
  }


  exportToExcel(data : IDetailedReportGrid[]){
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'detailed-raport');
    XLSX.writeFile(wb, 'Detailed-raport.xlsx');
    this.dialogRef.close();
  }
   
  openDialog(requestNumber: string){
    this.modal.open(RequestDetailsViewComponent, {
      width: '1000px',
      data: { requestNumber: requestNumber }
    });
  }  

  close() {
    this.dialogRef.close();
  }
}
